// form 组件混入

export default {
  props: {
    propsData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    form: {
      handler: function handler(val) {
        this.$emit('updateForm', val);
      },
      deep: true
    },
    propsData: {
      handler: function handler(val) {
        this.form = val;
      }
    }
  }
};